import useAuth from '../useAuth.js';

/**
 * True when the *real* (token-owning) user is allowed to impersonate.
 *
 * Reads the `canImpersonate` flag captured at login from the real user's scopes
 * (see `Login.tsx`). It is kept separate from `auth.scopes` / `auth.role`, which
 * `QuickUserToggler` overwrites with the *effective* (impersonated) user during a
 * session — so the flag stays true for the admin throughout impersonation and
 * across reloads (it is persisted). `auth.token` is now the SimpleJWT access
 * token and *could* be decoded, but the persisted flag remains the source of
 * truth: it survives token rotation and keeps this hook decode-free.
 *
 * Used to gate the active-session query so non-admins never hit the endpoint (it
 * 403s for them) while the banner keeps working for admins, even mid-impersonation.
 */
export const useCanImpersonate = (): boolean => {
  const auth = useAuth();

  return auth?.canImpersonate ?? false;
};
